"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TabList", {
    enumerable: true,
    get: function() {
        return TabList;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useTabList = require("./useTabList");
const _renderTabList = require("./renderTabList");
const _useTabListStylesstyles = require("./useTabListStyles.styles");
const _useTabListContextValues = require("./useTabListContextValues");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const TabList = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useTabList.useTabList_unstable)(props, ref);
    const contextValues = (0, _useTabListContextValues.useTabListContextValues_unstable)(state);
    (0, _useTabListStylesstyles.useTabListStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useTabListStyles_unstable')(state);
    return (0, _renderTabList.renderTabList_unstable)(state, contextValues);
});
TabList.displayName = 'TabList';
